import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { uniqBy } from 'lodash';
import AssessmentService from 'App/services/AssessmentService';

const useFetchAssessmentPublisherList = () => {
    const {
        data = [],
        isLoading,
        error,
    } = useQuery(['assessmentPublisherList'], AssessmentService.getAssessmentPublisherList);

    const therapyList = useMemo(() => {
        return uniqBy(
            data.map(({ therapy, groupId }) => ({ name: therapy, id: groupId })),
            'id'
        ).sort((a, b) => a.name.localeCompare(b.name));
    }, [data]);

    return {
        rawList: data,
        therapyList,
        isLoading,
        error,
    };
};

export default useFetchAssessmentPublisherList;
